import { Box, Link, LinkProps, Toolbar } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledLink = styled(Link)<LinkProps>(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  textDecoration: "none",
  fontWeight: 600,
  fontSize: 28,
  "&:hover": {
    textDecoration: "none",
  },
  [theme.breakpoints.down("md")]: {
    fontSize: 22,
  },
})) as typeof Link;

export const StyledGrow = styled(Box)({ flexGrow: 1 }) as typeof Box;

export const StyledToolbar = styled(Toolbar)({ minHeight: 64 }) as typeof Toolbar;
